export default function PHP_gethostbyaddr() {
  return (
    <div>
      <h1>PHP_gethostbyaddr</h1>
    </div>
  );
}
